export default {"src":"/_next/static/media/info-icon.40358a7f.svg","height":16,"width":16};